import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle, ClockCounterClockwise, ArrowUUpLeft, X } from "@phosphor-icons/react";
import { TypePill, fmtDate, fmtTime, addDays } from "./TaskPrimitives";

const REPORTS = [["Demain", 1], ["Dans 3 jours", 3], ["Semaine prochaine", 7]];

function ReportMenu({ t, today, onSnooze, close }) {
  return (
    <div className="fixed inset-x-3 bottom-20 z-30 card-base p-1.5 space-y-0.5 shadow-xl sm:absolute sm:inset-x-auto sm:right-0 sm:top-9 sm:bottom-auto sm:w-52 sm:shadow-none" data-testid={`task-report-menu-${t.task_id}`}>
      {REPORTS.map(([l, n]) => (
        <button key={l} className="w-full text-left text-[12px] px-2 py-1.5 rounded hover:bg-slate-100" data-testid={`task-report-opt-${n}-${t.task_id}`} onClick={() => { close(); onSnooze(t, addDays(today, n)); }}>
          {l} <span className="text-slate-400">· {fmtDate(addDays(today, n))}</span>
        </button>
      ))}
      <label className="block text-[12px] px-2 py-1.5 text-slate-600">Date personnalisée
        <input type="date" min={addDays(today, 1)} className="input-base h-8 mt-1 w-full text-[12px]" data-testid={`task-report-date-${t.task_id}`} onChange={(e) => { if (e.target.value) { close(); onSnooze(t, e.target.value); } }} />
      </label>
      <div className="text-[10px] text-slate-400 px-2 pb-1">Enregistré durablement · fuseau Europe/Paris</div>
    </div>
  );
}

export function TaskCard({ t, today, busy, onDone, onSnooze, onCancelSnooze }) {
  const [menu, setMenu] = useState(false);
  const late = t.bucket === "late";
  return (
    <div className={`rounded-xl border p-3 bg-white flex flex-col sm:flex-row sm:items-center gap-2 ${late ? "border-rose-200" : "border-slate-200"}`} data-testid={`task-card-${t.task_id}`}>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <TypePill type={t.type} />
          {late && <span className="text-[11px] font-bold text-rose-600" data-testid={`task-late-${t.task_id}`}>En retard · {t.late_days} j</span>}
          {t.bucket === "upcoming" && !t.snoozed_until && <span className="text-[11px] text-slate-500">Échéance {fmtDate(t.due)}</span>}
          {t.snoozed_until && <span className="text-[11px] text-amber-700 inline-flex items-center gap-1" data-testid={`task-snoozed-${t.task_id}`}>Reportée → {fmtDate(t.snoozed_until)}
            <button className="underline" onClick={() => onCancelSnooze(t)} data-testid={`task-cancel-snooze-${t.task_id}`} title="Annuler le report"><X size={10} /></button></span>}
        </div>
        <div className="font-bold text-[13px] text-slate-900 mt-1 truncate" data-testid={`task-objet-${t.task_id}`}>{t.objet}</div>
        <div className="text-[12px] text-slate-500">{t.motif}</div>
      </div>
      <div className="flex items-center gap-1.5 relative">
        <button className="btn-primary h-8 text-[12px] inline-flex items-center gap-1 disabled:opacity-50" disabled={busy} title={t.effect} onClick={() => onDone(t)} data-testid={`task-done-${t.task_id}`}><CheckCircle size={14} /> Effectué</button>
        <button className="btn-secondary h-8 text-[12px] inline-flex items-center gap-1 disabled:opacity-50" disabled={busy} onClick={() => setMenu(!menu)} data-testid={`task-report-${t.task_id}`}><ClockCounterClockwise size={14} /> Reporter</button>
        {menu && <ReportMenu t={t} today={today} onSnooze={onSnooze} close={() => setMenu(false)} />}
        {t.link && <Link to={t.link} className="text-[12px] text-slate-500 underline ml-1" data-testid={`task-open-${t.task_id}`}>Ouvrir</Link>}
      </div>
    </div>
  );
}

export function DoneCard({ l, busy, onUndo }) {
  return (
    <div className="rounded-xl border border-slate-200 p-3 bg-white flex flex-col sm:flex-row sm:items-center gap-2" data-testid={`task-card-${l.action_id}`}>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-2"><TypePill type={l.type} /><span className="text-[11px] text-slate-500">Échéance {fmtDate(l.due)}</span></div>
        <div className="font-bold text-[13px] text-slate-900 mt-1 truncate">{l.objet}</div>
        <div className="text-[12px] text-slate-500">{l.effect}</div>
      </div>
      <div className="flex items-center gap-2 text-[12px] text-emerald-700 font-bold">
        <CheckCircle size={16} weight="fill" /> Effectuée le {fmtTime(l.done_at)}
        <button className="btn-secondary h-8 text-[12px] inline-flex items-center gap-1 disabled:opacity-50" disabled={busy} onClick={() => onUndo(l)} data-testid={`task-undo-${l.action_id}`} title="Retire uniquement le pointage ; les échéances CRM déjà recalculées ne sont pas annulées"><ArrowUUpLeft size={12} /> Rouvrir</button>
      </div>
    </div>
  );
}
